<script>
  import Intro from "./Main.svelte";
</script>

<main>
  <Intro />
</main>

<style>
  main {
    width: 100%;
    height: 100%;
    max-width: 100%;
    margin: 0;
    padding: 0;
    background-color: aliceblue;
  }
</style>
